import camelCase from 'lodash/camelCase';
import deburr from 'lodash/deburr';
import trim from 'lodash/trim';

export default function slugify(str: string): string {
  // biome-ignore lint/suspicious/noControlCharactersInRegex: Regex is used to remove non-ASCII characters
  return camelCase(trim(deburr(str).replace(/[^\x00-\x7F]/g, '')));
}
